import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Link } from 'lucide-react';

const HomeLinkAccountsCard = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/link-accounts');
    }

    return (
        <div
            className="bg-white rounded-lg shadow-sm p-6 group cursor-pointer hover:shadow-md transition-shadow duration-300"
            onClick={handleClick}
        >
            <div className="flex items-center mb-4">
                <div
                    className="p-3 bg-indigo-100 rounded-full mr-4 group-hover:bg-indigo-200 transition-colors duration-300"
                >
                    <Link className="h-6 w-6 text-indigo-600"/>
                </div>
                <h4 className="text-lg font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors duration-300">
                    Link Accounts
                </h4>
            </div>
            <p className="text-gray-600">Connect your YouTube and TikTok accounts to manage your content</p>
            <div
                className="mt-4 flex items-center text-indigo-600 font-medium group-hover:translate-x-1 transition-transform duration-300"
            >
                Get Started <ChevronRight className="h-4 w-4 ml-1"/>
            </div>
        </div>
    );
}

export default HomeLinkAccountsCard;
